import {Component, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {Statistics} from './statistics.js';
import {TransactionalNames} from '../enums/TransactionalNames.js';

export enum PurchaseSKU {
    Invalid = -1,
    CoinSku1,
    CoinSku2,
    CoinSku3,
    CoinSku4,
    CoinSku5,
    CoinSku6,
    CoinDoubler,
    ElitePack,
    UnlockAll,
    DesertPack,
    FreezeDropSku1,
}

export class SkuAmount extends Component {
    static TypeName = 'sku-amount';

    @property.enum(Object.keys(PurchaseSKU).filter((e) => isNaN(Number(e))))
    sku: PurchaseSKU;

    @property.string('')
    backendIdentifier = '';

    @property.int(0)
    amount = 0;

    @property.enum(Object.keys(TransactionalNames).filter((e) => isNaN(Number(e))))
    stat: TransactionalNames;

    @property.bool(false)
    oneTimePurchase = false;

    // public PurchaseSKU sku;
    // public string backendIdentifier;
    // public int amount;
    // public TransactionalNames stat;
    // public bool oneTimePurchase;
    // public string acceptMessage;
    // public string acceptMessageButtonMessage;
    // public bool onSale;
    // public string saleDiscountAmount;
    // public int saleEndTimestamp;
    // public StoreInventoryItems storeInventoryItem;
    // public StoreTabs storeTab;
    // public ExperimentManager.Goal fireExperimentGoalOnPurchase = ExperimentManager.Goal.None;
    // [HideInInspector]public string moneyAmount;
    // [HideInInspector]public bool purchased;
}

export class PurchaseManager extends Component {
    static TypeName = 'purchase-manager';

    // Singleton
    private static _instance: PurchaseManager;
    static get instance(): PurchaseManager {
        return PurchaseManager._instance;
    }

    init() {
        if (PurchaseManager._instance) {
            console.error('There can only be one instance of PurchaseManager Component');
        }
        PurchaseManager._instance = this;
    }

    onActivate(): void {
        Statistics.instance.registerConfigChangedCallback(this._configChanged);
    }

    onDeactivate(): void {
        Statistics.instance.unRegisterConfigChangedCallback(this._configChanged);
    }

    update(dt: number) {}

    requestPurchase(item: PurchaseSKU) {}

    private _configChanged = () => {};

    private _waitForPlatform() {
        //TK: This methods was waiting on the IAP stuff to load,
        // not 100% sure what to do with it yet.
    }
}
